
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Education from "../pages/education/page";
import Experience from "../pages/experience/page";
import Patents from "../pages/patents/page";
import Papers from "../pages/papers/page";
import SecureAdminRoute from "../components/feature/SecureAdminRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/education",
    element: <Education />,
  },
  {
    path: "/experience",
    element: <Experience />,
  },
  {
    path: "/patents",
    element: <Patents />,
  },
  {
    path: "/papers",
    element: <Papers />,
  },
  {
    path: "/admin",
    element: <SecureAdminRoute />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
